"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var qrcode_react_1 = __importDefault(require("qrcode.react"));

var BurnerProvider_1 = require("../../BurnerProvider");

var Button_1 = __importDefault(require("../../components/Button"));

var Page_1 = __importDefault(require("../../components/Page"));

var PluginElements_1 = __importDefault(require("../../components/PluginElements"));

var AccountKeys_1 = __importDefault(require("../../data-providers/AccountKeys"));

var Section = function Section(_a) {
  var title = _a.title,
      children = _a.children;
  return react_1.default.createElement("div", null, react_1.default.createElement("h3", null, title), children);
};

var AdvancedPage = function AdvancedPage(_a) {
  var accounts = _a.accounts;

  var _b = react_1.default.useState(false),
      showPk = _b[0],
      setShowPk = _b[1];

  return react_1.default.createElement(Page_1.default, {
    title: "Advanced"
  }, react_1.default.createElement(AccountKeys_1.default, {
    account: accounts[0],
    render: function render(keys) {
      return keys && react_1.default.createElement(Section, {
        title: "Private Key"
      }, react_1.default.createElement("div", {
        style: {
          display: 'flex'
        }
      }, react_1.default.createElement(Button_1.default, {
        onClick: function onClick() {
          return setShowPk(!showPk);
        }
      }, showPk ? 'Hide' : 'Show', " PK"), react_1.default.createElement(Button_1.default, {
        onClick: function onClick() {
          return navigator.clipboard.writeText(keys.privateKey);
        }
      }, "Copy PK")), showPk && react_1.default.createElement("div", null, react_1.default.createElement("div", null, react_1.default.createElement(qrcode_react_1.default, {
        value: keys.privateKey,
        renderAs: "svg"
      })), react_1.default.createElement("div", null, react_1.default.createElement("input", {
        value: keys.privateKey,
        readOnly: true
      }))), react_1.default.createElement("div", null, react_1.default.createElement(Button_1.default, {
        onClick: keys.burnAccount
      }, "Burn PK")));
    }
  }), react_1.default.createElement(PluginElements_1.default, {
    position: "advanced"
  }));
};

exports.default = BurnerProvider_1.withBurner(AdvancedPage);